import AccordionList from 'components/accordion/AccordionList'
import { useMedicamentoUsoModalQuery } from 'graphql/hooks.generated'
import { ListaMedicamentoAtivoConcluidoQueryInput, ReceitaMedicamento } from 'graphql/types.generated'
import React, { useMemo, useState } from 'react'
import { getEditAtendProfId } from 'view/atendimentos/atendimento-individual/util-atendimentoIndividual'
import { GrupoReceitaMedicamento } from 'view/atendimentos/detail/soap/plano/prescricao-medicamento/model-prescricao'
import { groupAndSortReceitaMedicamentoByReceitaUsoContinuoGrupoId } from 'view/atendimentos/detail/soap/plano/prescricao-medicamento/utils/utils-prescricao'

import MedicamentosConcluidosTableFilter from './MedicamentosConcluidosTableFilter'

export interface MedicamentosConcluidosTableProps {
  prontuarioId: ID
  dataAtendimento: Instant
  atendimentoProfissionalId: ID
  isAtendimentoObservacao: boolean
  renderItemGroupHeader(grupo: ReceitaMedicamento[]): React.ReactNode
  renderItemGroupBody(grupo: ReceitaMedicamento[]): React.ReactNode
}

interface GrupoReceitaMedicamentoComId extends GrupoReceitaMedicamento {
  id: ID
}

export default function MedicamentosConcluidosTable(props: MedicamentosConcluidosTableProps) {
  const {
    prontuarioId,
    dataAtendimento,
    atendimentoProfissionalId,
    isAtendimentoObservacao = false,
    renderItemGroupHeader,
    renderItemGroupBody,
  } = props

  const editAtendProfId = getEditAtendProfId(isAtendimentoObservacao, atendimentoProfissionalId)

  const [currentFilter, setCurrentFilter] = useState<ListaMedicamentoAtivoConcluidoQueryInput>({
    prontuarioId,
    editAtendProfId,
    dataAtendimento,
    usoContinuo: false,
    ativo: false,
    pageParams: {
      unpaged: true,
    },
  })

  const {
    data: { listaMedicamento: listaMedicamentosConcluidos },
    loading: loadingConcluidos,
  } = useMedicamentoUsoModalQuery({
    variables: {
      input: currentFilter,
    },
  })

  const listaGruposConcluidosOrdenadosComId: GrupoReceitaMedicamentoComId[] = useMemo(() => {
    const medicamentos = (listaMedicamentosConcluidos?.content as ReceitaMedicamento[]) || []
    const grupos = groupAndSortReceitaMedicamentoByReceitaUsoContinuoGrupoId(medicamentos)

    return grupos.map(({ prescricoes }) => ({
      id: prescricoes.first().id,
      prescricoes: prescricoes,
    }))
  }, [listaMedicamentosConcluidos])

  const noResultMedicamentoConcluidos =
    !loadingConcluidos && listaGruposConcluidosOrdenadosComId.isEmpty()
      ? 'Nenhum medicamento com tratamento concluído'
      : null

  const data = useMemo(() => {
    return { content: listaGruposConcluidosOrdenadosComId, pageInfo: {} }
  }, [listaGruposConcluidosOrdenadosComId])

  return (
    <AccordionList<GrupoReceitaMedicamentoComId>
      header={<MedicamentosConcluidosTableFilter initialValues={currentFilter} onChange={setCurrentFilter} />}
      loading={loadingConcluidos}
      data={data}
      onChange={setCurrentFilter}
      accordionItemHeader={(item) => renderItemGroupHeader(item.prescricoes)}
      accordionItemBody={(item) => renderItemGroupBody(item.prescricoes)}
      noResultPlaceholder={noResultMedicamentoConcluidos}
      paginate={false}
    />
  )
}
